import { Combobox } from '@headlessui/react';
import { CheckIcon } from '@heroicons/react/20/solid';
import { SelectV2Option as SelectV2OptionType } from './types';
import { TooltipV2 } from '../tooltip/TooltipV2';

type SelectV2OptionProps = {
    isSelected: boolean;
    option: SelectV2OptionType;
    size: 'standard' | 'small';
};

const style = {
    fontSize: {
        standard: 'text-sm',
        small: 'text-xs placeholder:text-xs',
    },
};

function SelectV2Option({ isSelected, option, size }: SelectV2OptionProps): JSX.Element {
    return (
        <TooltipV2 message={option.disabledHint} disabled={!option.disabledHint || !option.isDisabled} position="right">
            <Combobox.Option
                key={option.value}
                value={option}
                className={({ active }): string =>
                    `flex items-center gap-3 cursor-default select-none relative py-2 pl-3 pr-4 ${option.isDisabled ? 'opacity-50' : ''} ${
                        active ? 'bg-indigo-600 dark:bg-indigo-500' : 'bg-transparent'
                    } `
                }
                disabled={option.isDisabled}
            >
                {({ active }): JSX.Element => (
                    <div className="flex justify-between w-full">
                        <div className="flex items-center gap-x-2">
                            {option.decoration}
                            <div className="flex flex-wrap gap-x-2">
                                <span
                                    className={`break-all ${style.fontSize[size]} ${
                                        active ? 'text-white dark:text-gray-50' : 'text-gray-700 dark:text-gray-200'
                                    } ${isSelected ? 'font-medium' : 'font-normal'}`}
                                >
                                    {option.label}
                                </span>
                                {option.description && (
                                    <span
                                        className={`${style.fontSize[size]} break-all ${
                                            active ? 'text-indigo-200' : 'text-gray-500 dark:text-white/[0.60]'
                                        } ml-0.5`}
                                    >
                                        {option.description}
                                    </span>
                                )}
                            </div>
                        </div>
                        {isSelected && (
                            <span className={`flex items-center pr-4' ${active ? 'text-white' : 'text-indigo-600 dark:text-indigo-400'}`}>
                                <CheckIcon className="h-5 w-5" />
                            </span>
                        )}
                    </div>
                )}
            </Combobox.Option>
        </TooltipV2>
    );
}

export default SelectV2Option;
